import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {
  constructor() { }

  private readJson<T>(key: string): T | null {
    try {
      const json = localStorage.getItem(key);
      return JSON.parse(json!) as T;
    } catch {
      return null;
    }
  }

  private writeJson<T>(key: string, value: T) {
    const json = JSON.stringify(value);
    localStorage.setItem(key, json);
  }

  private readonly AssigneesKey = 'changeover.task-list.selectedAssignees';
  get changeoverTaskListSelectedAssignees(): string[] | null { return this.readJson(this.AssigneesKey); }
  set changeoverTaskListSelectedAssignees(value: string[] | null) { this.writeJson(this.AssigneesKey, value); }

  private readonly ActiveLineIdKey = 'activeLineId';
  get activeLineId(): string | null { return this.readJson(this.ActiveLineIdKey); }
  set activeLineId(value: string | null) { this.writeJson(this.ActiveLineIdKey, value); }
}
